import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 384.97 384.97",
  "content": "<symbol viewBox=\"0 0 384.97 384.97\" id=\"icon-download\"><path stroke=\"#000\" stroke-width=\"20\" d=\"M372.939 264.667c-6.641 0-12.03 5.39-12.03 12.03v84.212H24.061v-84.212c0-6.641-5.39-12.03-12.03-12.03S0 270.056 0 276.697v96.242c0 6.641 5.39 12.03 12.03 12.03h360.909c6.641 0 12.03-5.39 12.03-12.03v-96.242c.001-6.641-5.389-12.03-12.03-12.03z\" /><path stroke=\"#000\" stroke-width=\"10\" d=\"M183.703 285.202c4.68 4.632 12.512 4.68 17.191 0l84.2-83.009a11.942 11.942 0 0 0 0-17.011c-4.74-4.704-12.439-4.704-17.179 0l-63.46 62.558V12.03c0-6.641-5.438-12.03-12.151-12.03s-12.151 5.39-12.151 12.03v235.71l-63.46-62.558c-4.752-4.704-12.439-4.704-17.179 0a11.931 11.931 0 0 0 0 17.011l84.189 83.009z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/icons/icon-download.svg
// module id = 873
// module chunks = 74